import type { FC } from 'react';
import type { LinkProps } from 'next/link';
import Link from 'next/link';

type NextLinkProps = Pick<LinkProps, 'passHref' | 'href'> &
  React.ComponentProps<'a'> & { ariaLabel?: string; isAriaHidden?: boolean };

export const NextLink: FC<NextLinkProps> = ({
  children,
  onClick,
  href,
  passHref,
  className,
  ariaLabel,
  isAriaHidden = false,
}) => {
  if (passHref) {
    return (
      <Link href={href} passHref={passHref} legacyBehavior tabIndex={isAriaHidden ? -1 : 0} aria-hidden={isAriaHidden}>
        {children}
      </Link>
    );
  }

  return (
    <Link
      href={href}
      onClick={onClick || (() => {})}
      className={className}
      aria-label={ariaLabel}
      aria-hidden={isAriaHidden}
      tabIndex={isAriaHidden ? -1 : 0}
    >
      {children}
    </Link>
  );
};
